export const PortFolio2 = () => {
  return (
    <div className="bg-1">
      <div className="container">
        <div className="text-color-gray-100">test</div>
      </div>
    </div>
  );
};
